import { render, staticRenderFns } from "./love.vue?vue&type=template&id=67b0f3d9&scoped=true&"
import script from "./love.vue?vue&type=script&lang=js&"
export * from "./love.vue?vue&type=script&lang=js&"
import style0 from "./love.vue?vue&type=style&index=0&id=67b0f3d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b0f3d9",
  null
  
)

export default component.exports